// Source/Expandable/Debounce.ts
function debounce(func, wait) {
  let timeout = null;
  return (...args) => {
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = window.setTimeout(() => {
      func(...args);
    }, wait);
  };
}

// Source/Expandable/mod.ts
var Extra_Threshold = 2;

class Expandable extends HTMLElement {
  controller = new AbortController;
  connectedCallback() {
    const { signal } = this.controller;
    const update = this.update.bind(this);
    const debounced = debounce(update, 100);
    window.addEventListener("resize", debounced, { signal });
    this.$input.addEventListener("change", update, { signal });
    requestAnimationFrame(update);
  }
  disconnectedCallback() {
    this.controller.abort();
  }
  update() {
    const { $content: content } = this;
    let row = 1;
    const elements = Array.from(content.children);
    if (elements.length == 0)
      return;
    let offset = 0, space = 0;
    for (const element of elements) {
      const sibling = element.previousElementSibling;
      if (sibling && element.offsetTop > sibling.offsetTop)
        row++;
      if (row > Extra_Threshold) {
        offset = sibling.getBoundingClientRect().top - sibling.parentElement.getBoundingClientRect().top;
        space = sibling.getBoundingClientRect().height;
        break;
      }
    }
    const height = offset > 0 ? `${offset + space}px` : "auto";
    this.style.setProperty("---Height", height);
    const expand = height != "auto";
    if (!expand || this.$input.checked) {
      const element = elements.at(elements.length - 1);
      space = element.offsetHeight;
    }
    this.style.setProperty("---Space", `${space}px`);
    this.dataset.expand = String(expand);
  }
}

// Source/Filtings-Section/Component.ts
class FiltingsSection extends Expandable {
  observer;
  connectedCallback() {
    super.connectedCallback();
    const { signal } = this.controller;
    const onChange = this.onChange.bind(this);
    const initial = this.initial.bind(this);
    const observer = new MutationObserver(onChange);
    observer.observe(this.container, {
      childList: true,
      subtree: true
    });
    window.addEventListener("Boost:After-Render", () => {
      setTimeout(initial, 100);
      setTimeout(initial, 200);
      setTimeout(initial, 300);
      setTimeout(initial, 400);
    }, { signal });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.observer.disconnect();
  }
  onChange(mutations) {
    console.debug("OnChange");
    for (const mutation of mutations)
      for (const node of Array.from(mutation.addedNodes)) {
        if (!(node instanceof HTMLElement))
          continue;
        if (!node.classList.contains("boost-sd__filter-option-item"))
          continue;
        if (!node.querySelector(`button[ data-action ^= '${this.key}' ]`))
          continue;
        if (!node.closest(`#boost-sd_filter-tree-mobile`))
          continue;
        this.addLink(node);
      }
    this.update();
  }
  initial() {
    const { list } = this;
    if (!list)
      return;
    this.onRender();
    const items = Array.from(list.children);
    for (const item of items)
      this.addLink(item);
    this.update();
  }
  onRender() {
    const { $content: content } = this;
    Array.from(content.childNodes).forEach((node) => node.remove());
  }
  addLink(item) {
    const { $content: content } = this;
    const parent = item.querySelector(`button`);
    const title = item.querySelector(`.boost-sd__filter-option-item-label`).textContent.trim();
    const button = document.createElement("button");
    button.classList.add("Filtings-Link");
    button.addEventListener("click", () => parent.click());
    button.innerText = title;
    const remover = document.querySelector(`
            button[
                metadata *= '${this.key}'
            ][
                metadata *= '${title}'
            ]
        `);
    const isChecked = !!remover;
    button.dataset.checked = String(isChecked);
    content.appendChild(button);
  }
  get $input() {
    return this.querySelector(`.Filtings-Input`);
  }
  get $content() {
    return this.querySelector(`.Filtings-Content`);
  }
  get list() {
    return document.querySelector(`#${this.key}`);
  }
  get container() {
    return document.querySelector(`.boost-sd__filter-product-list`);
  }
  get key() {
    return this.dataset.key;
  }
}

// Source/Filtings-Section/mod.ts
customElements.define("filtings-section", FiltingsSection);
